import { QCONTENT_DETAILS_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { useItemSet } from '@exam-management/common/item-set-provider';
import { NavigateBackLinkWithHistory, ItemSetStatusTag } from '@exam-management/components';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { ItemSetNavigationTabs } from '@exam-management/qcontent-management';
import { useParams } from '@exam-management/router';
import { EllipsisText, Flex, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { ItemSetQuestionDetailHeaderMenu } from '../item-set-question-detail-header-menu';

export default function ItemSetQuestionDetailHeader() {
  const { structureId } = useParams('/qbank-structures/:structureId');

  const { qBankStructureInformation } = useQBankStructure();
  const { code, name: qbsName } = qBankStructureInformation;

  const { itemSet } = useItemSet();
  const { name: itemSetName, refCode, status, updatedAt } = itemSet;

  return (
    <PageHeader
      title={`${itemSetName} (${refCode})`}
      linkAdornment={
        <NavigateBackLinkWithHistory
          fallbackPath='/qbank-structures/:structureId/qcontents'
          matchPatterns='/qbank-structures/:structureId/qcontents'
          fallbackParams={{ structureId }}
          label='Back'
        />
      }
      endAdornment={
        <>
          <ItemSetStatusTag
            data-testid={QCONTENT_DETAILS_DATA_TEST_ID.ITEM_SET_STATUS_TAG}
            status={status}
            size='large'
          />
          <ItemSetQuestionDetailHeaderMenu />
        </>
      }
      subtitleSection={
        <>
          <Flex sx={{ gap: (theme) => theme.spacing(4), alignItems: 'center' }}>
            <EllipsisText variant='body2' maxLines={2}>{`CourseID: ${code}`}</EllipsisText>
            <EllipsisText variant='body2' maxLines={2}>
              {qbsName}
            </EllipsisText>
          </Flex>
          <Text color='text.secondary' variant='body2'>
            Last Modified: {formatDateTime(updatedAt)}
          </Text>
        </>
      }
      tabs={<ItemSetNavigationTabs />}
    />
  );
}
